window.practiceAi = window.practiceAi || {};

window.practiceAi.copyElementText = async (elementId) => {
    try {
        const el = document.getElementById(elementId);
        if (!el) return false;

        const text = (el.innerText || "").trim();
        if (!text) return false;

        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        return false;
    }
};

window.practiceAi.copyPlainText = async (text) => {
    try {
        const t = (text || "").trim();
        if (!t) return false;

        await navigator.clipboard.writeText(t);
        return true;
    } catch {
        return false;
    }
};
